import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { TypeOrmModule } from "@nestjs/typeorm";
import { EmployyeHodMapping } from "./employee-mapping-entity";
import { employeeHodMappingController } from "./employee-mapping-controller";
import { EmployeeHodMappingService } from "./employee-mapping-service";



@Module({
    imports: [
        TypeOrmModule.forFeature([EmployyeHodMapping]),
    ],
    controllers: [employeeHodMappingController],
    providers: [EmployeeHodMappingService, ApplicationExceptionHandler]
})
export class EmployeeMappingModule {

}